// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1VmXt","footer":"Form_footer__23kOy"};